export default __webpack_public_path__ + "static/media/lawyer.beec9cec.svg";